// import React, { useContext, useEffect, useState } from "react";
// import { BiCaretLeft } from "react-icons/bi";
// import { TbCurrencyRupee } from "react-icons/tb";
// import CartCard from "./CartCard";
// import { ToastContainer } from "react-toastify";
// import { Link } from "react-router-dom";
// import { errorToaster, successToaster } from "../../utils/index";
// import { UserContext } from "./../../context/userContext";
// import apiClient from "../../utils/api";
// import { userInfo } from "../../utils/appInfo";

// export default function Cart() {
//   const { updateUserData } = useContext(UserContext);
//   const [data, setData] = useState([]);
//   const [cartData, setCartData] = useState([]);
//   const [taxData, setTaxData] = useState({ fuel: 0, gst: 0 });
//   const [cartValue, setCartValue] = useState(0);
//   const [userData, setUserData] = useState({});
//   const [courierPrice, setCourierPrice] = useState({
//     g250: 0,
//     g500: 0,
//     upto3kg: 0,
//     above3kg: 0,
//   });
//   const [stateData, setStateData] = useState(null);
//   const [isChecked, setIsChecked] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const fetchData = async () => {
//     try {
//       const { data: cData = [] } = await apiClient.post(`get/cart.php`, {
//         user_id: userInfo().email,
//       });
//       setData(cData);
//       updateUserData({ cart: cData });
//     } catch (error) {
//       console.error("Error fetching cart data:", error);
//       setData([]);
//     }
//   };

//   const fetchStateData = async () => {
//     try {
//       const res = await apiClient.post(`get/user.php`, {
//         user_id: userInfo().email,
//       });
//       setStateData(res.data[0] || null);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       setStateData(null);
//     }
//   };

//   useEffect(() => {
//     if (stateData?.state) {
//       courierPriceData(stateData);
//     }
//   }, [stateData]);

//   const postCartData = (i) => {
//     if (!data[i]?.product_id) return;

//     apiClient
//       .post(`put/cart.php`, {
//         user_id: userData.email,
//         product_id: data[i].product_id,
//         quantity: data[i].quantity,
//       })
//       .then((res) => {
//         setCartData(res.data);
//       })
//       .catch(console.error);
//   };

//   useEffect(() => {
//     let value = 0;
//     data.forEach((info) => {
//       value = value + (info.quantity || 0) * (info.offer_price || 0);
//     });
//     setCartValue(value);
//   }, [data]);

//   const removeProduct = async (id) => {
//     try {
//       await apiClient.post(`delete/cart.php`, {
//         user_id: userData.email,
//         product_id: id,
//       });
//       await fetchData();
//       errorToaster({ msg: "Item removed from your cart" });
//     } catch (err) {
//       console.error("Error removing product:", err);
//       errorToaster({ msg: "Failed to remove item" });
//     }
//   };

//   const loadRazorpayScript = (src) => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = src;
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const checkoutProduct = async () => {
//     if (!stateData || stateData.state === "0") {
//       alert("Please provide your address in your profile page");
//       return;
//     }

//     setLoading(true);

//     try {
//       const deliveryCost = isChecked === 1 ? 0 : getDeliveryCost();
//       const totalOrderCost = cartValue + deliveryCost;

//       const orderResponse = await apiClient.post(`post/payment.php`, {
//         user_id: userData.email,
//         order_cost: totalOrderCost,
//         product_id: data.map((d) => d.product_id),
//         quantity: data.map((d) => d.quantity),
//         product_name: data.map((d) => d.product_name),
//       });

//       const orderData = orderResponse.data;
//       const scriptLoaded = await loadRazorpayScript(
//         "https://checkout.razorpay.com/v1/checkout.js"
//       );

//       if (!scriptLoaded) {
//         errorToaster({ msg: "Razorpay SDK failed to load. Are you online?" });
//         return;
//       }

//       const options = {
//         key: orderData.key || process.env.REACT_APP_RAZORPAY_KEY_ID,
//         amount: orderData.amount,
//         currency: orderData.currency || "INR",
//         name: orderData.name || "Your Store",
//         description: orderData.description || "Payment for products",
//         order_id: orderData.order_id,
//         handler: async function (response) {
//           try {
//             const verificationResponse = await apiClient.post(
//               `post/verify_payment.php`,
//               {
//                 order_id: response.razorpay_order_id,
//                 payment_id: response.razorpay_payment_id,
//                 signature: response.razorpay_signature,
//                 user_id: userData.email,
//                 amount: totalOrderCost,
//               }
//             );

//             if (verificationResponse.data.success) {
//               successToaster({ msg: "Payment successful!" });
//               fetchData();
//             } else {
//               errorToaster({ msg: "Payment verification failed" });
//             }
//           } catch (error) {
//             console.error("Payment verification error:", error);
//             errorToaster({ msg: "Payment verification failed" });
//           }
//         },
//         prefill: {
//           name: userData.name || "",
//           email: userData.email || "",
//           contact: userData.mobile || "",
//         },
//         theme: {
//           color: "#3399cc",
//         },
//         modal: {
//           ondismiss: () => setLoading(false),
//         },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Checkout error:", error);
//       errorToaster({ msg: "Error processing payment" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const courierPriceData = async (val = {}) => {
//     try {
//       const res = await apiClient.post(`get/delivery_cost.php`, {
//         state: val.state,
//       });
//       setCourierPrice(
//         res.data[0] || {
//           g250: 0,
//           g500: 0,
//           upto3kg: 0,
//           above3kg: 0,
//         }
//       );
//     } catch (err) {
//       console.error("Error fetching courier price:", err);
//       setCourierPrice({
//         g250: 0,
//         g500: 0,
//         upto3kg: 0,
//         above3kg: 0,
//       });
//     }
//   };

//   const getTaxData = async () => {
//     try {
//       const res = await apiClient.post(`get/additional_cost.php`, {});
//       setTaxData(res.data[0] || { fuel: 0, gst: 0 });
//     } catch (error) {
//       console.error("Error fetching tax data:", error);
//       setTaxData({ fuel: 0, gst: 0 });
//     }
//   };

//   const calculateBasePrice = (weight = 0) => {
//     if (!weight) return 0;

//     let cost = 0;
//     if (weight <= 250) {
//       cost = courierPrice.g250 || 0;
//     } else if (weight <= 500) {
//       cost = courierPrice.g500 || 0;
//     } else if (weight <= 3000) {
//       const remWeigh = weight - 500;
//       const remCalc = Math.ceil(remWeigh / 500);
//       cost =
//         remCalc * (courierPrice.upto3kg || 0) + Number(courierPrice.g500 || 0);
//     } else {
//       const remCalc = Math.ceil(weight / 1000);
//       cost = remCalc * (courierPrice.above3kg || 0);
//     }
//     return cost;
//   };

//   const getDeliveryCost = () => {
//     if (!stateData?.state || !data.length) return 0;

//     let weight = 0;
//     data.forEach((item) => {
//       weight += (item.weight || 0) * (item.quantity || 0);
//     });

//     const accCost = calculateBasePrice(weight);
//     const fuelSurcharge = (accCost * (taxData.fuel || 0)) / 100;
//     const gst = (Math.ceil(accCost + fuelSurcharge) * (taxData.gst || 0)) / 100;
//     return Math.ceil(accCost + fuelSurcharge + gst);
//   };

//   useEffect(() => {
//     const initialize = async () => {
//       try {
//         const user = userInfo();
//         setUserData(user);
//         await fetchData();
//         await fetchStateData();
//         await getTaxData();
//       } catch (error) {
//         console.error("Initialization error:", error);
//       }
//     };

//     const timer = setTimeout(() => {
//       initialize();
//       window.scrollTo(0, 0);
//     }, 500);

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <>
//       <section className="h-100 h-custom productPage">
//         <div className="container-fluid py-4 h-100">
//           <div className="row d-flex justify-content-center align-items-center h-100">
//             <div className="col">
//               <div className="card">
//                 <div className="card-body p-4">
//                   <div className="row">
//                     <div className="col-lg-7">
//                       <div className="mb-3">
//                         <Link to="/" className="text-body text-decoration-none">
//                           <BiCaretLeft
//                             className="me-0"
//                             style={{ fontSize: "1.5em", marginTop: "-5px" }}
//                           />
//                           <span>Continue shopping</span>
//                         </Link>
//                       </div>
//                       <hr />

//                       <div className="d-flex justify-content-between align-items-center mb-4">
//                         <div>
//                           <p className="mb-1">Shopping cart</p>
//                           <p className="mb-0">
//                             You have {data.length} items in your cart
//                           </p>
//                         </div>
//                       </div>
//                       <CartCard
//                         cartData={(i) => postCartData(i)}
//                         data={data}
//                         deleteValue={removeProduct}
//                         setData={setData}
//                       />
//                     </div>
//                     <div className="col-lg-5">
//                       <div className="card bg-success text-white rounded-3">
//                         <div className="card-body">
//                           <h4 className="text-uppercase">Price Details</h4>
//                           <hr className="my-3" />
//                           <div className="d-flex justify-content-between">
//                             <p className="mb-2 text-uppercase">sub total</p>
//                             <p className="mb-2">
//                               <TbCurrencyRupee style={{ marginTop: "-3px" }} />
//                               {cartValue}
//                             </p>
//                           </div>
//                           <div className="d-flex justify-content-between">
//                             <p className="mb-2 text-uppercase">
//                               {isChecked === 1
//                                 ? "Free Delivery"
//                                 : "Delivery charges"}
//                             </p>
//                             <p className="mb-2">
//                               <TbCurrencyRupee style={{ marginTop: "-3px" }} />
//                               {isChecked === 1
//                                 ? 0
//                                 : stateData?.state !== "0"
//                                 ? getDeliveryCost()
//                                 : 0}
//                             </p>
//                           </div>

//                           <hr className="my-3" />
//                           <div className="d-flex justify-content-between mb-2">
//                             <p className="mb-2 text-uppercase">Total Price</p>
//                             <p className="mb-2">
//                               <TbCurrencyRupee style={{ marginTop: "-3px" }} />
//                               {stateData?.state !== "0"
//                                 ? cartValue +
//                                   (isChecked === 1 ? 0 : getDeliveryCost())
//                                 : cartValue}
//                             </p>
//                           </div>

//                           <button
//                             disabled={!cartValue || loading}
//                             type="button"
//                             className="btn btn-light btn-block btn-sm"
//                             onClick={checkoutProduct}
//                           >
//                             {loading ? (
//                               <span
//                                 className="spinner-border spinner-border-sm"
//                                 role="status"
//                                 aria-hidden="true"
//                               ></span>
//                             ) : (
//                               <span className="text-uppercase">Checkout</span>
//                             )}
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <ToastContainer />
//     </>
//   );
// }
import React, { useContext, useEffect, useState } from "react";
import { BiCaretLeft } from "react-icons/bi";
import { TbCurrencyRupee } from "react-icons/tb";
import CartCard from "./CartCard";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { errorToaster, successToaster } from "../../utils/index";
import { UserContext } from "./../../context/userContext";
import apiClient from "../../utils/api";
import "../Cart/cart.css"

export default function Cart() {
  const { updateUserData } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  let [cartValue, setCartValue] = useState(0);
  const [userData, setUserData] = useState({});
  const [courierPrice, setCourierPrice] = useState([]);
  const [stateData, setStateData] = useState({});
  const [isChecked, setIsChecked] = useState(0);

  const fetchData = async () => {
    try {
      const { data: cData = [] } = await apiClient.post(`get/cart.php`, {
        user_id: userInfo().email,
      });
      setData(cData);
      updateUserData({ cart: cData });
    } catch (error) {
      setData([]);
    }
  };

  const fetchStateData = async () => {
    await apiClient
      .post(`get/user.php`, {
        user_id: userInfo().email,
      })
      .then((res) => {
        setStateData(res.data[0]);
      });
  };

  useEffect(() => {
    if (stateData?.state) courierPriceData(stateData);
  }, [stateData]);

  const postCartData = (i) => {
    apiClient
      .post(`put/cart.php`, {
        user_id: userData.email,
        product_id: data[i].product_id,
        quantity: data[i].quantity,
      })
      .then((res) => {
        setCartData(res.data);
      });
  };

  useEffect(() => {
    let value = 0;
    data.map((info) => {
      value = value + info.quantity * info.offer_price;
    });
    setCartValue(value);
  }, [data]);

  const removeProduct = async (id) => {
    await apiClient
      .post(`delete/cart.php`, {
        user_id: userData.email,
        product_id: id,
      })
      .then((res) => {
        fetchData();
        errorToaster({ msg: "Item removed from your cart" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkoutProduct = async () => {
    let productID = data.map((d) => d.product_id);
    let quantity = data.map((d) => d.quantity);
    let product_name = data.map((d) => d.product_name);

    let deliveryCost =
      isChecked === 1 ? 0 : stateData.state !== "0" ? getDeliveryCost() : 0;
    let totalOrderCost = cartValue + deliveryCost;

    try {
      // 1️⃣ Create order from backend
      const { data: order } = await apiClient.post(`post/create_order.php`, {
        amount: totalOrderCost * 100, // convert ₹ → paise
        currency: "INR",
        receipt: "order_rcptid_" + Date.now(),
      });

      console.log("📌 Backend Order Response:", order);

      if (!order || !order.id) {
        errorToaster({ msg: "Order creation failed!" });
        return;
      }

      // 2️⃣ Open Razorpay Checkout
      const options = {
        key: "rzp_live_RQsmTSHQPjXuRO", // frontend key
        amount: order.amount,
        currency: order.currency,
        name: "My Shop",
        description: "Order Payment",
        order_id: order.id,
        handler: async function (response) {
          console.log("📌 Razorpay Success:", response);

          // 3️⃣ Send payment verify to backend
          try {
            const { data: verify } = await apiClient.post(
              `post/verify_payment.php`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_id: userData.email,
                product_id: productID,
                quantity: quantity,
                product_name: product_name,
                order_cost: totalOrderCost,
              }
            );

            if (verify.success) {
              successToaster({ msg: "Payment successful!" });
            } else {
              errorToaster({ msg: "Payment verification failed!" });
            }
          } catch (err) {
            errorToaster({ msg: "Payment verification error!" });
          }
        },
        prefill: {
          name: userData.name,
          email: userData.email,
          contact: userData.mobile,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (err) {
      console.error("Payment error:", err);
      errorToaster({ msg: "Payment failed!" });
    }
  };

  // const checkoutProduct = async () => {
  //   let productID = data.map((d) => d.product_id);
  //   let quantity = data.map((d) => d.quantity);
  //   let product_name = data.map((d) => d.product_name);

  //   let deliveryCost =
  //     isChecked === 1 ? 0 : stateData.state !== "0" ? getDeliveryCost() : 0;
  //   let totalOrderCost = cartValue + deliveryCost;

  //   let payload = {
  //     user_id: userData.email,
  //     order_cost: totalOrderCost,
  //     product_id: productID,
  //     quantity: quantity,
  //     product_name: product_name,
  //     // Optional: if you want to differentiate orders placed without payment
  //     payment_status: "Pending",
  //   };

  //   try {
  //     await apiClient.post(`post/order.php`, payload);
  //     successToaster({ msg: "Order placed successfully without payment!" });
  //     fetchData(); // Refresh cart
  //   } catch (error) {
  //     console.error("Error placing order:", error);
  //     errorToaster({ msg: "Failed to place order." });
  //   }
  // };

  const courierPriceData = async (val = {}) => {
    await apiClient
      .post(`get/delivery_cost.php`, {
        state: val.state,
      })
      .then((res) => {
        setCourierPrice(res.data[0]);
      })
      .catch((err) => console.log(err));
  };

  const getTaxData = () => {
    apiClient.post(`get/additional_cost.php`, {}).then((res) => {
      setTaxData(res.data[0]);
    });
  };

  // useEffect(() => {
  //   apiClient
  //     .get(`get/free_delivery.php`, {
  //       params: { sno: "1" }, // Ensure sending params correctly
  //     })
  //     .then((response) => {
  //       if (response.data.length > 0) {
  //         const fetchedValue = Number(response.data[0].free); // Convert to number
  //         console.log("Fetched Free Delivery Value:", fetchedValue);
  //         setIsChecked(fetchedValue);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // }, []);

  const calculateBasePrice = (weight = 0) => {
    let cost = 0;
    if (!weight) {
      return 0;
    }
    if (weight <= 250) {
      cost = courierPrice.g250;
    } else if (weight <= 500) {
      cost = courierPrice.g500;
    } else if (weight <= 3000) {
      let remWeigh = weight - 500;
      let remCalc = Math.ceil(remWeigh / 500);
      cost = remCalc * courierPrice.upto3kg + Number(courierPrice.g500);
    } else {
      let remCalc = Math.ceil(weight / 1000);
      let cost3k = remCalc * courierPrice.above3kg;
      cost = Number(cost3k);
    }
    return cost;
  };
  const getDeliveryCost = () => {
    let weight = 0;
    data.map((item, i) => {
      let maxWeight = item.weight * item.quantity;
      weight = weight + maxWeight;
    });
    let accCost = calculateBasePrice(weight);
    accCost = Number(accCost) + (accCost * taxData.fuel) / 100;
    let netCost = Math.ceil(accCost) + (Math.ceil(accCost) * taxData.gst) / 100;
    return Math.ceil(netCost);
  };

  useEffect(() => {
    setTimeout(async () => {
      await fetchData();
      await fetchStateData();
      setUserData(userInfo());
      getTaxData();
    }, 500);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @media (max-width: 998px) {
        .custom-mobile-margin {
          margin-top: 10% !important;
        }
      }
        @media (max-width: 750px) {
        .custom-mobile-margin {
          margin-top: 15% !important;
        }
      }
        @media (max-width: 500px) {
        .custom-mobile-margin {
          margin-top: 19% !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <section className="h-100 h-custom productPage">
        <div className="container-fluid py-4 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col custom-mobile-margin">
              <div className="card">
                <div className="cards-body-new p-4">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="mb-3">
                        <Link to="/" className="text-body text-decoration-none">
                          <BiCaretLeft
                            className="me-0 cart-left-arrow"
                            style={{ fontSize: "1.5em", marginTop: "-5px" }}
                          />
                          <span className="rupees-size">Continue shopping</span>
                        </Link>
                      </div>
                      <hr />

                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <p className="mb-1 rupees-size">Shopping cart</p>
                          <p className="mb-0 rupees-size">
                            You have {data.length} items in your cart
                          </p>
                        </div>
                      </div>
                      <CartCard
                        cartData={(i) => postCartData(i)}
                        data={data}
                        deleteValue={removeProduct}
                        setData={setData}
                      />
                    </div>
                    <div className="col-lg-5 mt-3">
                      <div className="card bg-success text-white rounded-3">
                        <div className="cards-body-new m-3">
                          <h4 className="text-uppercase rupees-size-new">Price Details</h4>
                          <hr className="my-3" />
                          <div className="d-flex justify-content-between">
                            <p className="mb-2 text-uppercase rupees-size-new-1">sub total</p>
                            <p className="mb-2 rupees-size-new-1">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {cartValue}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="mb-2 text-uppercase rupees-size-new-1">
                              {isChecked === 1
                                ? "Free Delivery"
                                : "Delivery charges"}
                            </p>
                            <p className="mb-2 rupees-size-new-1">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {isChecked === 1
                                ? 0
                                : stateData?.state !== "0"
                                ? getDeliveryCost()
                                : 0}
                            </p>
                          </div>

                          <hr className="my-3" />
                          <div className="d-flex justify-content-between mb-2">
                            <p className="mb-2 text-uppercase rupees-size-new-1">Total Price</p>
                            <p className="mb-2 rupees-size-new-1">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {stateData?.state !== "0"
                                ? cartValue +
                                  (isChecked === 1 ? 0 : getDeliveryCost())
                                : cartValue}
                            </p>
                          </div>

                          <button
                            disabled={!cartValue}
                            type="button"
                            className="btn btn-light btn-block btn-sm"
                          >
                            <div className="d-flex justify-content-between">
                              <span
                                target="_blank"
                                className="text-uppercase rupees-size-new-1"
                                onClick={() => {
                                  if (stateData?.state == "0") {
                                    alert(
                                      "Please provide your address in your profile page"
                                    );
                                  } else {
                                    checkoutProduct();
                                  }
                                }}
                              >
                                Checkout
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
